module.exports = __webpack_public_path__ + "img/trimestre.6b2a1902.png";